import { purchaseHistoryActions } from './purchaseHistorySlice'
import { fetchHelper } from '../../../api/api'
import { CartItemTypes } from '../../Cart/cartSlice'
import { fetchPlan } from '../../Plans/plansApi'
import {
    fetchClassDetails,
    fetchCourseDetails,
} from '../../../api/apiFunctions'

export const getPurchaseHistory = email => async dispatch => {
    dispatch(purchaseHistoryActions.purchaseHistoryRequest())
    try {
        const response = await fetchHelper(`Paymentlog/MyPayments/${email}`)
        let payments = response.data
        const paymentsData = await Promise.all(
            payments.map(({ items }) => fetchItemsData(items))
        )

        payments = payments.map((payment, paymentIndex) => ({
            ...payment,
            items: payment.items.map((item, itemIndex) => ({
                ...item,
                data: paymentsData[paymentIndex][itemIndex] || {},
            })),
        }))

        dispatch(purchaseHistoryActions.purchaseHistoryRequestSuccess(payments))
    } catch (e) {
        dispatch(purchaseHistoryActions.purchaseHistoryRequestError(e.message))
    }
}

const fetchItemsData = async items => {
    return Promise.all(
        items.map(({ orderType, orderTypeId }) => {
            if (orderType === CartItemTypes.Plan) {
                return fetchPlan(orderTypeId)
            } else if (orderType === CartItemTypes.Course) {
                return fetchCourseDetails(orderTypeId)
            } else {
                return fetchClassDetails(orderTypeId)
            }
        })
    )
}
